
import { Component,Prop, BaseMixins } from '@/lib';

@Component
export default class  SiderTrigger extends BaseMixins {
    name:string='SiderTrigger';
    @Prop({type:Boolean,default:false}) collapsed:boolean;
    @Prop({type:String,default:'navicon-round'}) icon:string;
    @Prop({type:Number,default:26}) size:number;

    handleChange () {
      this.$emit('on-change', !this.collapsed)
    }
}

